import { notePayload } from '../../mylibrary/helper/notesPayload';
import { ActiveTabs } from '../types/enums/ActiveTabs';
import { AdvancedSettingsInterface, FAQ, GeneralSettings, SEO } from '../types/interfaces/AdvancedSettings';
import { CourseBasicDetails } from '../types/interfaces/CourseBasicDetails';
import * as actionTypes from './actionTypes';

export const addCourseBasicDetails = (payload: CourseBasicDetails) => {
  return {
    type: actionTypes.ADD_COURSE_BASIC_DETAILS,
    payload,
  };
};

export const updateCourseBasicDetails = (payload: CourseBasicDetails) => {
  return {
    type: actionTypes.UPDATE_COURSE_BASIC_DETAILS,
    payload,
  };
};

export const getActiveGoals = () => {
  // console.log('Inside action ');
  return {
    type: actionTypes.GET_ACTIVE_GOALS,
  };
};

export const getBulkReport = (payload: any) => {
  return {
    type: actionTypes.GET_BULK_REPORT,
    payload
  };
}
export const getActiveCourses = () => {
  return {
    type: actionTypes.GET_ACTIVE_COURSES,
  };
};

export const getActiveTreeData = (payload: string) => {
  return {
    type: actionTypes.TREE_DATA_VIEW_SUCCESS,
    payload,
  };
};

export const getUserSuggestions = (payload: string) => {
  return {
    type: actionTypes.GET_USER_SUGGESTIONS,
    payload,
  };
};

export const storeGeneralSettings = (payload: GeneralSettings) => {
  return {
    type: actionTypes.STORE_GENERAL_SETTINGS,
    payload,
  };
};

export const storeFAQ = (payload: FAQ) => {
  return {
    type: actionTypes.STORE_FAQ,
    payload,
  };
};

export const storeSEO = (payload: SEO) => {
  return {
    type: actionTypes.STORE_SEO,
    payload,
  };
};

export const saveAdvancedSettings = (payload: AdvancedSettingsInterface) => {
  return {
    type: actionTypes.SAVE_ADVANCED_SETTINGS,
    payload,
  };
};

export const checkAdvancedSettingsMandatoryFields = () => {
  return {
    type: actionTypes.CHECK_ADVANCED_SETTINGS_MANDATORY_FIELDS
  }
}

export const storePackageId = (payload: string) => {
  return {
    type: actionTypes.STORE_PACKAGE_ID,
    payload,
  };
};

export const addCourseTestSeries = (payload: CourseBasicDetails) => {
  console.log('action dispatch', payload);
  return {
    type: actionTypes.ADD_COURSE_TEST_SERIES,
    payload,
  };
};

export const fetchExistingScheduledTests = (payload: string) => {
  return {
    type: actionTypes.FETCH_EXISTING_SCHEDULED_TESTS,
    payload,
  };
};

export const fetchMapTestSuggestions = (payload: any) => {
  return {
    type: actionTypes.FETCH_MAP_TEST_SUGGESTIONS,
    payload,
  };
};

export const fetchCoursesByScheduleID = (payload: any) => {
  return {
    type: actionTypes.COURSES_BY_SCHEDULE_ID,
    payload,
  };
};

export const fetchScheduleTests = (payload: string) => {
  return {
    type: actionTypes.FETCH_SCHEDULED_TESTS,
    payload,
  };
};

export const getBasicInfo = (payload: string) => {
  return {
    type: actionTypes.GET_BASIC_INFO,
    payload,
  };
};

export const setBulkTestUploadData = (payload: any) => {
  return {
    type: actionTypes.SET_BULK_TEST_UPLOAD_DATA,
    payload,
  };
};

export const getCourseDetails = (payload: any) => {
  return {
    type: actionTypes.GET_COURSE_DETAILS,
    payload,
  };
};

export const setActiveTab = (payload: any) => {
  return {
    type: actionTypes.SET_ACTIVE_TAB,
    payload,
  };
};

export const saveTabData = (payload: any) => {
    return {
        type: actionTypes.SAVE_TAB_DATA,
        payload
    }
}

export const rejectCourse = (payload: any) => {
  return {
    type: actionTypes.REJECT_COURSE,
    payload
  };
}

export const approveAndPublishCourse = (payload: any) => {
  return {
    type: actionTypes.APPROVE_AND_PUBLISH,
    payload
  };
}

export const publishCourse =  (payload: any) => {
    return {
        type: actionTypes.PUBLISH_COURSE,
        payload
    }
}
export const saveAdvancedSetting =  (payload: any) => {
    return {
        type: actionTypes.SAVE_ADVANCED_SETTING,
        payload
    }
}
export const setTestCount =  (payload: any) => {
    return {
        type: actionTypes.SET_TEST_COUNT,
        payload
    }
}
export const fetchContentFromPackages =  (payload: any) => {
  return {
      type: actionTypes.FETCH_CONTENT_FROM_PACKAGES,
      payload
  }
}